export const GET_HISTORY = "GET_HISTORY"
export const GET_HISTORY_PENDING = "GET_HISTORY_PENDING"
export const GET_HISTORY_FAILED = "GET_HISTORY_REJECTED"
export const GET_HISTORY_FULFILLED = "GET_HISTORY_FULFILLED"
export const UPDATE_HISTORY_FILTER = "UPDATE_HISTORY_FILTER"
export const UPDATE_HISTORY = "UPDATE_HISTORY"
export const UPDATE_MULTIPLE_HISTORY_FILTERS = "UPDATE_MULTIPLE_HISTORY_FILTERS"
